import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "@fontsource/inter/latin-400.css"
import "@fontsource/inter/latin-500.css"
import "@fontsource/inter/latin-600.css"
import "@fontsource/inter/latin-700.css"
import "@fontsource/fraunces/latin-500.css"
import "@fontsource/fraunces/latin-600.css"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"

import { App } from "./app"
import "./i18n"
import "./styles.css"

const queryClient = new QueryClient({
  defaultOptions: { queries: { gcTime: 5 * 60_000, refetchOnWindowFocus: false } },
})
const root = document.getElementById("root")
if (!root) throw new Error("Root element not found")
createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
)
